import React, { memo } from 'react'
import { getMergedClassNames } from '../../utils/HTMLutils'
import Input, { InputProps } from '../input/Input'
import './BannerPesquisaCpfCnpj.scss'
const rootClassName = 'banner-pesquisa-cpf-cnpj'

interface BannerPesquisaCpfCnpjProps {
  title?: string
  subtitle?: string
  inputProps?: InputProps
  urlImg?: string
  theme?: 'white' | 'secondary-light' | 'secondary-lighter'
}

function BannerPesquisaCpfCnpj(props: BannerPesquisaCpfCnpjProps) {
  return (
    <div className={getMergedClassNames([rootClassName, props.theme])}>
      <div className={`${rootClassName}-left`}>
        <div className={`${rootClassName}-title`}>{props.title}</div>
        <div className={`${rootClassName}-sub-title nunito`}>
          {props.subtitle}
        </div>
        <div className={`${rootClassName}-input`}>
          <Input {...props.inputProps} />
        </div>
      </div>
      <div
        className={`${rootClassName}-image`}
        style={{ backgroundImage: `url(${props.urlImg})` }}
      >
        <img alt='img' src={props.urlImg} />
      </div>
    </div>
  )
}

BannerPesquisaCpfCnpj.defaultProps = {
  theme: 'secondary-lighter'
}

export default memo(BannerPesquisaCpfCnpj)
